import React from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';
import {
  headerCellLeftClass,
  sortableHeaderButtonClass,
} from './styles.ts';

export type SortableHeaderCellProps<K extends string> = {
  label: string;
  columnKey: K;
  sort: { key: K; dir: 'asc' | 'desc' };
  onSortChange: (key: K) => void;
};

export const SortableHeaderCell = <K extends string,>({
  label,
  columnKey,
  sort,
  onSortChange,
}: SortableHeaderCellProps<K>): React.ReactElement => {
  const active = sort.key === columnKey;

  const handleClick = (): void => {
    onSortChange(columnKey);
  };

  return (
    <th className={headerCellLeftClass}>
      <button type="button" onClick={handleClick} className={sortableHeaderButtonClass}>
        {label}
        {active ? (
          sort.dir === 'asc' ? (
            <ArrowUp className="h-4 w-4 text-blue-600 flex-shrink-0" />
          ) : (
            <ArrowDown className="h-4 w-4 text-blue-600 flex-shrink-0" />
          )
        ) : (
          <ArrowUpDown className="h-4 w-4 text-gray-400 opacity-70 flex-shrink-0" />
        )}
      </button>
    </th>
  );
};
